import { useEffect, useState } from 'react';

import {
  EnterpriseAssociation,
  getEnterpriseAssociation,
} from '@/services/enterpriseAssociation';

export const useEnterpriseAssociation = (enabled = true) => {
  const [association, setAssociation] = useState<EnterpriseAssociation | null>(null);

  useEffect(() => {
    let active = true;
    if (!enabled) {
      setAssociation(null);
      return () => {
        active = false;
      };
    }
    const load = () =>
      getEnterpriseAssociation()
        .then((value) => {
          if (active) setAssociation(value || null);
        })
        .catch(() => {
          if (active) setAssociation(null);
        });
    void load();
    const timer = window.setInterval(load, 30_000);
    const onFocus = () => void load();
    window.addEventListener('focus', onFocus);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled]);

  return { association, refresh: async () => setAssociation(await getEnterpriseAssociation()) };
};
